// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"dd4fce0e","684":"dd4fce0e","882":"980997c6"}[chunkId] + ".chunk.css";
};